import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";

import MarketingFooter from "@/components/MarketingFooter";
import { MarketingNavBar } from "@/components/MarketingNavBar";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/_marketing-header-layout")({
  component: RouteComponent,
});

function RouteComponent() {
  const location = useLocation();

  return (
    <div
      className={cn(
        "min-h-screen flex flex-col text-slate-normal instrument-sans relative z-0",
        location.pathname.startsWith("/about") &&
          "bg-slatedark-1 text-slatedark-12",
      )}
    >
      <header className="w-screen md:max-w-[calc(1216px+280px+280px)] mx-auto px-4 md:px-10 xl:px-16 py-4 flex flex-col gap-6 md:gap-8">
        <MarketingNavBar
          showSearch={location.pathname.startsWith("/blog")}
          variant={location.pathname.startsWith("/about") ? "light" : undefined}
        />
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  );
}
